<template>
    <div class="ProgressBar">
      <div id="progressBackground">
        <div id="progress" v-bind:style="[baseStyle, { width: progressWidth + '%' }]" ></div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'PSProgressBar',
  props: [
    'progressWidth'
  ],
  data() {
    return {
      baseStyle: {
        height: '10px',
        'background-color': '#156af2'
      }
    }
  }
}
</script>

<style scoped>
  #progressBackground {
    width: 100%;
    background-color: #3c3c3b;
  }
</style>



// WEBPACK FOOTER //
// src/components/GuestServices/SubmitSupportRequest/PSProgressBar.vue